/**
 * Hook to calculate cache age from React Query data
 */

import { useEffect, useState } from 'react';

interface UseCacheAgeOptions {
  dataUpdatedAt?: number; // Timestamp from React Query
  enabled?: boolean;
}

export function useCacheAge({ dataUpdatedAt, enabled = true }: UseCacheAgeOptions) {
  const [cacheAge, setCacheAge] = useState(0);

  useEffect(() => {
    if (!enabled || !dataUpdatedAt) {
      setCacheAge(0);
      return;
    }

    // Calculate initial age
    const calculateAge = () => {
      const now = Date.now();
      const ageMs = now - dataUpdatedAt;
      return Math.floor(ageMs / 1000); // Convert to seconds
    };

    setCacheAge(calculateAge());

    // Update every second
    const interval = setInterval(() => {
      setCacheAge(calculateAge());
    }, 1000);

    return () => clearInterval(interval);
  }, [dataUpdatedAt, enabled]);

  return cacheAge;
}
